


























































































import {
	Component,
	Vue,
	Prop,
	Mixins
} from 'vue-property-decorator';
import BaseMixin from '@/components/mixins/base';
import CaptionedField from '@/views/charts/captioned-field.vue';
import QueryBuilderMixin from '@/components/mixins/queryBuilderMixin';
import { DxRequiredRule, DxValidator, DxStringLengthRule } from 'devextreme-vue/validator';
import DxTextBox from 'devextreme-vue/text-box';
import { DxSelectBox } from 'devextreme-vue/select-box';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxList from 'devextreme-vue/list';
import DxButton from 'devextreme-vue/button';
import DxColorBox from 'devextreme-vue/color-box';
import DxCheckBox from 'devextreme-vue/check-box';
import { DxTooltip } from 'devextreme-vue/tooltip';
import ChartCreateQueryFields from '@/views/charts/chart-create-query-fields.vue';
import GranularitySelection from '@/views/charts/granularity-selection.vue';
import ChartRenderNew from '@/components/charts/ChartRenderNew.vue';
import { QueryBuilder } from '@cubejs-client/vue';
import FilterBuilder from '@/views/charts/filter-builder.vue';
import { Portal, PortalTarget } from 'portal-vue';
import { IChartConfig } from '@/components/charts/resultSetTransform';
import { isNil } from 'lodash';
import { TCubeMeasure } from '@cubejs-client/core';

@Component({
	components: {
		CaptionedField,
		DxTextBox,
		DxSelectBox,
		DxDropDownBox,
		DxList,
		DxButton,
		DxTooltip,
		DxColorBox,
		DxCheckBox,
		QueryBuilder,
		ChartCreateQueryFields,
		GranularitySelection,
		ChartRenderNew,
		Portal, PortalTarget,
		FilterBuilder,
		DxRequiredRule, DxValidator, DxStringLengthRule
	}, name: 'ChartCreateMultiple'
})
export default class QueryBuilderGlobal extends Mixins(QueryBuilderMixin, BaseMixin) {
	@Prop({ type: String }) chartType!: string;
	@Prop() genericFieldsDictionary!: Record<string, boolean>;
	@Prop({ type: Array }) chartConfig!: IChartConfig[] | null;
	@Prop() chartTypes!: string[];
	@Prop({ type: Boolean }) groupedByWeek!: boolean;
	@Prop({ type: Boolean }) loading!: boolean;
	@Prop() cubejsApi!: any;
	@Prop() globalFilter!: any;
	@Prop() globalQuery?: any;
	@Prop() drillDownDimension?: string[];

	internalGroupedByWeek = false;
	internalTimeDimensions: string[] = [];
	isDimensionsDropDownBoxOpened = false;
	internalChartType = 'line';
	internalGlobalQuery: any | null = null;
	preloadedQuery: any = {};
	internalChartConfig: IChartConfig[] | null = null;
	internalDrillDownDimension: string[] | null = null;
	internalGlobalFilter: any = null;

	async created() {

		this.$watch(() => this.internalChartType, this.onInternalChartTypeChange);
		this.$watch(() => this.chartType, this.onChartTypeChange, { immediate: true });

		this.$watch(() => this.internalTimeDimensions, this.onInternalTimeDimensionsChange, { immediate: true });

		this.$watch(() => this.globalQuery, this.onGlobalQueryChange, { immediate: true });
		this.$watch(() => this.internalGlobalQuery, this.onInternalinternalGlobalQueryChange);

		this.$watch(() => this.chartConfig, this.onChartConfigChange, { immediate: true });
		this.$watch(() => this.internalChartConfig, this.onInternalinternalChartConfigChange);

		this.$watch(() => this.groupedByWeek, this.onGroupByWeekChange, { immediate: true });
		this.$watch(() => this.internalGroupedByWeek, this.onInternalGroupByWeekChange);

		this.$watch(() => this.drillDownDimension, this.onDrillDownDimensionChange, { deep: true });

		this.$watch(() => this.globalFilter, this.onGlobalFilterChange, { immediate: true });
		this.$watch(() => this.internalGlobalFilter, this.onInternalGlobalFilterChange);
	}

	onChangeChartTypeDropDownBoxValue({ value }: { value: string }, updateChartType: (internalChartType: string) => void): void {

		updateChartType(value);
		this.internalChartType = value;
		//Set pie for showing percentage by default
		this.assurePercentageOptionIsPresent();

	}

	assurePercentageOptionIsPresent() {
		if (!_.isNil(this.chartConfig) && isNil(this.chartConfig[0].isPercentage))
			this.$set(this.chartConfig, 'isPercentage', this.internalChartType === 'pie');
		else if (this.internalChartType === 'pie' && !_.isNil(this.chartConfig) && !isNil(this.chartConfig[0].isPercentage) && !this.chartConfig[0]?.isPercentage)
			this.chartConfig[0].isPercentage = true;
	}

	onChangeDimensionsDropDownBoxValue({ addedItems, removedItems }: { addedItems: { name: string }[], removedItems: { name: string }[] }, setDimentions: (names: string[]) => void, dimentions: { name: string }[]): void {
		if (addedItems.length > 0) {
			const itemsToAdd = addedItems.filter(item => dimentions
				.map(dim => dim.name)
				.includes(item.name) == false);

			setDimentions([...dimentions.map(x => x.name), ...itemsToAdd.map(x => x.name)]);
		}
		else if (removedItems.length > 0) {
			const removedNames = removedItems.map(x => x.name);
			setDimentions([...dimentions.map(x => x.name).filter(x => !removedNames.includes(x))]);
		}
	}

	availableTimeDimensionsFiltered(availableTimeDimensions) {
		return this.filterAndMapFields(availableTimeDimensions, this.genericFieldsDictionary);
	}

	availableDimensionsFiltered(availableDimensions) {
		return this.filterAndMapFields(availableDimensions, this.genericFieldsDictionary);
	}


	groupByGranularity(granularityName) {
		this.internalGroupedByWeek = (granularityName === 'week') ? true : false;
	}

	// DO NOT REMOVE UNTIL THE REWORK OF THE COMPONENT
	onDimensionsUpdate(dimensions: any[]) {
		if (!isNil(this.chartConfig)) {
			if (Array.isArray(dimensions)) {
				this.notifyDimensionUpdate(dimensions);
			}
			else {
				this.notifyDimensionUpdate([]);
			}
		}
	}

	notifyDimensionUpdate(dimensions) {
		if (!isNil(this.internalChartConfig)) {
			if (_.isArray(this.internalChartConfig)) {
				this.internalChartConfig.forEach(config => this.$set(config, 'selectedDimensions', [...dimensions]));
			}
			else {
				this.$set(this.internalChartConfig, 'selectedDimensions', [...dimensions]);
			}

			this.$emit('update:dimensions', dimensions);
		}
	}

	updateGlobalFilter(val) {
		this.internalGlobalFilter = val;
		this.$emit('update:globalFilter', val);
	}

	onChartTypeChange(): void {
		this.internalChartType = this.chartType;
	}

	async onInternalChartTypeChange(): Promise<void> {
		this.$emit('update:chartType', this.internalChartType);
	}

	async onInternalTimeDimensionsChange(): Promise<void> {
		this.$emit('update:global-time-dimensions', this.internalTimeDimensions);
	}

	async onInternalinternalGlobalQueryChange(): Promise<void> {
		this.$emit('update:globalQuery', this.internalGlobalQuery);
	}

	async onInternalinternalChartConfigChange(): Promise<void> {
		this.$emit('update:chartConfig', this.internalChartConfig);
	}

	async onGroupByWeekChange(val): Promise<void> {
		this.internalGroupedByWeek = val;
	}

	async onInternalGroupByWeekChange(val): Promise<void> {
		this.$emit('update:groupedByWeek', val);
	}

	async onGlobalQueryChange(val): Promise<void> {
		if (!isNil(val) && !isNil(val.query))
			this.preloadedQuery = val.query;
	}

	async onChartConfigChange(val): Promise<void> {
		this.internalChartConfig = _.cloneDeep(val);
	}

	async onDrillDownDimensionChange(val): Promise<void> {
		this.internalDrillDownDimension = val;
		this.preloadedQuery.dimensions = val;
	}

	async onInternalGlobalFilterChange(): Promise<void> {
		this.$emit('update:globalFilter', this.internalGlobalFilter);
	}

	onGlobalFilterChange(): void {
		this.internalGlobalFilter = this.globalFilter;
	}
}
